<template>
  <div class="common">
    <a-tabs v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name" >
        <keep-alive v-if="tabCur==item.key">
          <component
          :is="item.comp"
          :tabType="item.key"
          :nsStCd="item.nsStCd"
          :fnsStCd="item.fnsStCd"
          :pcsStCd="item.pcsStCd"
          ></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import goldFinancingQuery from "@/pages/circulation/gold-financing/gold-financing-query"
import goldFinancing from "@/pages/circulation/gold-financing/gold-financing"
const systemDate = window.sessionStorage.getItem('systemDate') || new Date();
export default {
  components: {
    goldFinancing,goldFinancingQuery
  },
  name:"borrow",
  data() {
    return {
      tabData:[
        {
          name:"祺信融资",
          key:"goldFinancing",
          comp:goldFinancing
        },
        {
          name:"待复核",
          key:"borrowPendingReview",
          comp:goldFinancingQuery,
          nsStCd:"",
          fnsStCd:'6'
        },
        {
          name:"待平台审核",
          key:"borrowpendingApproval",
          comp:goldFinancingQuery,
          nsStCd:"",
          fnsStCd:'8',
          // pcsStCd:''
        },
        {
          name:"待资方审核",
          key:"borrowpendingApproval2",
          comp:goldFinancingQuery,
          nsStCd:"",
          fnsStCd:'9',
          // pcsStCd:'0,1'
        },
        {
          name:"待放款",
          key:"borrowpendingLoan",
          comp:goldFinancingQuery,
          nsStCd:"",
          fnsStCd: 11,
          // pcsStCd: 2
        },
        {
          name:"放款中",
          key:"borrowpendingLoanIng",
          comp:goldFinancingQuery,
          nsStCd:"",
          fnsStCd: 14,
          // pcsStCd: 2
        },
        {
          name:"已放款",
          key:"borrowLoaned",
          comp:goldFinancingQuery,
          nsStCd:"",
          fnsStCd: 12,
          // pcsStCd: 2,
        },
        {
          name:"全部",
          key:"borrowAll",
          comp:goldFinancingQuery,
        },
      ],
      tabCur:"goldFinancing"
    }
  },
  computed:{
    ...mapGetters({
        userObj:"home/getUserObj"

    })
  },
  created() {
  },
  mounted() {

  },
  methods: {


  },
  activated() {

  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/circulation/borrow.vue